import { render, staticRenderFns } from "./NewsSearchResults.vue?vue&type=template&id=2827054a&"
import script from "./NewsSearchResults.vue?vue&type=script&lang=js&"
export * from "./NewsSearchResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports